import styled from 'styled-components';

export const StyledWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: auto;
	visibility: hidden;
	opacity: 0;
	display: none;
`;

export const StyledText = styled.p`
	margin: 3rem 0 1.5rem;
	font-weight: 600;
`;
